



























































































































import { mapActions, mapState } from 'vuex';
import * as vr from '@/helpers/validation';
import {
  integer,
  required,
  validNumber,
  positiveNumber
} from '@/helpers/validation';

import {
  updateCopystakeAggregationAggregatorMode,
  updateCopystakeAggregationCasinoMode,
  updateCopystakeAggregatorCasinoConfig,
  updateCopystakeAggregatorOperatorConfig,
  updateCopystakeAggregatorVimaConfig
} from '@/api/CopyStake/Integration';
import { AxiosError } from 'axios';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import {
  CopyStakeAggregationOperatorTypeNaming,
  CopyStakeAggregatorTypeNaming,
  ECopyStakeAggregationOperatorType,
  ECopyStakeAggregatorType,
  TCopystakeOperatorAggregatorCasinoParams,
  TCopystakeOperatorAggregatorOperatorParams,
  TCopystakeOperatorAggregatorVimaParams
} from '@/api/schema';

type TAggregationSettingsValues = {
  operatorType: ECopyStakeAggregationOperatorType;
  casinoId: string;
  casinoName: string;
  isActive: boolean;
  integrationId: string;
  integrationKey: string;
  integrationUrl: string;
  apiKey: string;
  callbackUrl: string;
  ttl: number;
  aggregatorType: ECopyStakeAggregatorType;
  aggregatorEnabled: boolean;
};

type TAggregationSettingsData = {
  ECopyStakeAggregationOperatorType?: typeof ECopyStakeAggregationOperatorType;
  operatorTypeList: ReadonlyArray<{
    text: string;
    value: ECopyStakeAggregationOperatorType;
  }>;
  aggregatorTypeList: ReadonlyArray<{
    text: string;
    value: ECopyStakeAggregatorType;
  }>;

  values: TAggregationSettingsValues;
  formValid: boolean;
  isSubmitting: boolean;
};

type TValidator = (v: string) => boolean | string;

export default {
  name: 'OnboardingCopystakeAggregationSettings',
  props: {
    brandName: {
      type: String,
      default: (): string => ''
    }
  },
  data(): TAggregationSettingsData {
    return {
      ECopyStakeAggregationOperatorType,
      operatorTypeList: Object.freeze([
        {
          text: CopyStakeAggregationOperatorTypeNaming.CASINO,
          value: ECopyStakeAggregationOperatorType.CASINO
        },
        {
          text: CopyStakeAggregationOperatorTypeNaming.AGGREGATOR,
          value: ECopyStakeAggregationOperatorType.AGGREGATOR
        }
      ]),
      aggregatorTypeList: Object.freeze([
        {
          text: CopyStakeAggregatorTypeNaming.PLATIPUS,
          value: ECopyStakeAggregatorType.PLATIPUS
        },
        {
          text: CopyStakeAggregatorTypeNaming.VIMA,
          value: ECopyStakeAggregatorType.VIMA
        }
      ]),

      values: {
        operatorType: null,

        casinoId: null,
        casinoName: null,
        isActive: false,

        integrationId: null,
        integrationKey: null,
        integrationUrl: null,

        apiKey: null,
        callbackUrl: null,
        ttl: null,

        aggregatorType: null,
        aggregatorEnabled: false
      },

      formValid: false,
      isSubmitting: false
    };
  },
  computed: {
    ...mapState('Onboarding', ['copyStakeAggregationConfig', 'loading']),
    isCasinoOperatorType(): boolean {
      return (
        this.values.operatorType === ECopyStakeAggregationOperatorType.CASINO
      );
    },
    isAggregatorOperatorType(): boolean {
      return (
        this.values.operatorType ===
        ECopyStakeAggregationOperatorType.AGGREGATOR
      );
    },

    isVimaAggregatorType(): boolean {
      return this.values.aggregatorType === ECopyStakeAggregatorType.VIMA;
    },

    isVimaConfigUpdated(): boolean {
      const config = this.copyStakeAggregationConfig;

      return (
        this.values.aggregatorType !== config.aggregatorType ||
        this.brandName !== config.brandName ||
        this.values.integrationId !== config.vimaIntegrationId ||
        this.values.integrationKey !== config.vimaIntegrationKey ||
        this.values.integrationUrl !== config.vimaIntegrationUrl
      );
    },
    isOperatorTypeUpdated(): boolean {
      return (
        this.values.operatorType !==
        this.copyStakeAggregationConfig.operatorType
      );
    },
    isConfigUpdated(): boolean {
      if (this.isVimaAggregatorType) {
        return this.isVimaConfigUpdated;
      } else if (this.isOperatorTypeUpdated) {
        return true;
      } else if (this.isCasinoOperatorType) {
        return (
          this.values.casinoId !== this.copyStakeAggregationConfig.casinoId ||
          this.values.casinoName !==
            this.copyStakeAggregationConfig.casinoName ||
          this.brandName !== this.copyStakeAggregationConfig.brandName
        );
      } else if (this.isAggregatorOperatorType) {
        return (
          this.values.apiKey !== this.copyStakeAggregationConfig.apiKey ||
          this.values.callbackUrl !==
            this.copyStakeAggregationConfig.callbackUrl ||
          this.values.ttl !== this.copyStakeAggregationConfig.ttl ||
          this.values.aggregatorType !==
            this.copyStakeAggregationConfig.aggregatorType ||
          this.brandName !== this.copyStakeAggregationConfig.brandName
        );
      } else {
        return false;
      }
    },
    isStatusUpdated(): boolean {
      if (this.isVimaAggregatorType) {
        return false;
      } else if (this.isCasinoOperatorType) {
        return (
          this.values.isActive !== !!this.copyStakeAggregationConfig.isActive
        );
      } else if (this.isAggregatorOperatorType) {
        return (
          this.values.aggregatorEnabled !==
          !!this.copyStakeAggregationConfig.aggregatorEnabled
        );
      } else {
        return false;
      }
    },
    isBrandNameUpdated(): boolean {
      return this.brandName !== this.copyStakeAggregationConfig.brandName;
    },
    isShowEnableSwitch(): boolean {
      if (this.isCasinoOperatorType) {
        return !!(
          this.copyStakeAggregationConfig.casinoId &&
          this.copyStakeAggregationConfig.casinoName
        );
      } else if (this.isAggregatorOperatorType) {
        return !!(
          this.copyStakeAggregationConfig.apiKey &&
          this.copyStakeAggregationConfig.callbackUrl &&
          this.copyStakeAggregationConfig.ttl &&
          this.copyStakeAggregationConfig.aggregatorType
        );
      } else {
        return false;
      }
    },
    isLoading(): boolean {
      return this.loading.copyStakeAggregationConfig;
    },
    isDisabledFields(): boolean {
      return this.isSubmitting || this.isLoading;
    },
    isPlatipusSaved(): boolean {
      return !!(
        this.copyStakeAggregationConfig.operatorType &&
        this.getSavedAggregatorType() === ECopyStakeAggregatorType.PLATIPUS
      );
    },
    isDisabledOperatorTypeSelect(): boolean {
      // Vima is always Casino; saved Platipus operator type can't be changed
      return (
        this.isDisabledFields ||
        this.isVimaAggregatorType ||
        this.isPlatipusSaved
      );
    },
    isDisabledSubmitBtn(): boolean {
      return (
        !(
          this.isConfigUpdated ||
          this.isStatusUpdated ||
          this.isBrandNameUpdated
        ) ||
        !this.formValid ||
        !this.brandName ||
        this.isSubmitting
      );
    },

    validationRules(): {
      operatorType: TValidator[];
      casinoId: TValidator[];
      casinoName: TValidator[];
      integrationId: TValidator[];
      integrationKey: TValidator[];
      integrationUrl: TValidator[];
      apiKey: TValidator[];
      callbackUrl: TValidator[];
      ttl: TValidator[];
      aggregatorType: TValidator[];
    } {
      return {
        operatorType: [(v) => required(v, 'Operator Type')],

        casinoId: [(v) => required(v, 'Casino ID')],
        casinoName: [(v) => required(v, 'Casino Name')],

        integrationId: [(v) => required(v, 'Integration ID')],
        integrationKey: [(v) => required(v, 'Integration Key')],
        integrationUrl: [(v) => required(v, 'Integration URL'), vr.url],

        apiKey: [(v) => required(v, 'API Key')],
        callbackUrl: [(v) => required(v, 'Callback URL'), vr.url],
        ttl: [
          (v) => required(v, 'TTL'),
          integer,
          validNumber,
          positiveNumber
        ],
        aggregatorType: [(v) => required(v, 'Aggregator Type')]
      };
    }
  },
  mounted(): void {
    this.parseSavedSettings();
  },
  watch: {
    'values.operatorType': {
      handler(newVal: string): void {
        this.$emit('changeOperatorType', newVal);
      },
      immediate: true
    }
  },
  methods: {
    ...mapActions('Onboarding', ['getCopyStakeAggregationConfigData']),
    parseSavedSettings(): void {
      this.getCopyStakeAggregationConfigData()
        .then(() => {
          this.values.operatorType =
            this.copyStakeAggregationConfig.operatorType ||
            ECopyStakeAggregationOperatorType.CASINO;

          this.values.casinoId =
            this.copyStakeAggregationConfig.casinoId || null;
          this.values.casinoName =
            this.copyStakeAggregationConfig.casinoName || null;
          this.values.isActive =
            this.copyStakeAggregationConfig.isActive || false;

          this.values.integrationId =
            this.copyStakeAggregationConfig.vimaIntegrationId || null;
          this.values.integrationKey =
            this.copyStakeAggregationConfig.vimaIntegrationKey || null;
          this.values.integrationUrl =
            this.copyStakeAggregationConfig.vimaIntegrationUrl || null;

          this.values.apiKey = this.copyStakeAggregationConfig.apiKey || null;
          this.values.callbackUrl =
            this.copyStakeAggregationConfig.callbackUrl || null;
          this.values.ttl = this.copyStakeAggregationConfig.ttl || null;
          this.values.aggregatorType = this.getSavedAggregatorType();
          this.values.aggregatorEnabled =
            this.copyStakeAggregationConfig.aggregatorEnabled || false;
        })
        .catch((err: AxiosError) => {
          errorToastMessage(err);
        });
    },
    changeOperatorTypeHandler(): void {
      this.$refs.form?.resetValidation();
    },
    getSavedAggregatorType(): ECopyStakeAggregatorType {
      const { aggregatorType, operatorType } =
        this.copyStakeAggregationConfig;

      if (aggregatorType) return aggregatorType;

      // operators configured before Vima was added are Platipus
      return operatorType
        ? ECopyStakeAggregatorType.PLATIPUS
        : ECopyStakeAggregatorType.VIMA;
    },
    changeAggregatorTypeHandler(type: ECopyStakeAggregatorType): void {
      if (type === ECopyStakeAggregatorType.VIMA) {
        this.values.operatorType = ECopyStakeAggregationOperatorType.CASINO;
      } else if (this.isPlatipusSaved) {
        this.values.operatorType =
          this.copyStakeAggregationConfig.operatorType;
      }

      this.$refs.form?.resetValidation();
    },
    submitHandler(): void {
      if (this.isSubmitting) return;

      if (this.isVimaAggregatorType) {
        this.updateVimaConfig();
      } else if (this.isCasinoOperatorType) {
        this.updateAggregatorCasinoConfig();
      } else if (this.isAggregatorOperatorType) {
        this.updateAggregatorOperatorConfig();
      }
    },
    updateAggregatorOperatorConfig(): void {
      this.isSubmitting = true;

      const promises = [];

      if (this.isConfigUpdated) {
        const config: TCopystakeOperatorAggregatorOperatorParams = {
          apiKey: this.values.apiKey,
          ttl: this.values.ttl,
          callbackUrl: this.values.callbackUrl,
          brandName: this.brandName,
          aggregatorType: this.values.aggregatorType,
          aggregatorEnabled: this.values.aggregatorEnabled
        };

        promises.push(updateCopystakeAggregatorOperatorConfig(config));
      } else if (this.isStatusUpdated) {
        promises.push(
          updateCopystakeAggregationAggregatorMode(
            this.values.aggregatorEnabled
          )
        );
      }

      Promise.all(promises)
        .then((): void => {
          this.$toast.success(
            'CopyStake Aggregator Operator settings updated.'
          );

          this.parseSavedSettings();
        })
        .catch(() => {
          this.$toast.error(
            'CopyStake Aggregator Operator settings update failed.'
          );
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    updateVimaConfig(): void {
      this.isSubmitting = true;

      const config: TCopystakeOperatorAggregatorVimaParams = {
        brandName: this.brandName,
        integrationId: this.values.integrationId,
        integrationKey: this.values.integrationKey,
        integrationUrl: this.values.integrationUrl
      };

      updateCopystakeAggregatorVimaConfig(config)
        .then((): void => {
          this.$toast.success('CopyStake Vima settings updated.');

          this.parseSavedSettings();
        })
        .catch(() => {
          this.$toast.error('CopyStake Vima settings update failed.');
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    updateAggregatorCasinoConfig(): void {
      this.isSubmitting = true;

      const promises = [];

      if (this.isConfigUpdated) {
        const config: TCopystakeOperatorAggregatorCasinoParams = {
          casinoId: this.values.casinoId,
          casinoName: this.values.casinoName,
          brandName: this.brandName
        };

        promises.push(updateCopystakeAggregatorCasinoConfig(config));
      }

      if (this.isStatusUpdated) {
        promises.push(
          updateCopystakeAggregationCasinoMode(this.values.isActive)
        );
      }

      Promise.all(promises)
        .then((): void => {
          this.$toast.success(
            'CopyStake Aggregator Casino settings updated.'
          );

          this.parseSavedSettings();
        })
        .catch(() => {
          this.$toast.error(
            'CopyStake Aggregator Casino settings update failed.'
          );
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    }
  }
};
